export default "__VITE_ASSET__EAiuOnpp__"